import {ButtonStyle} from 'ui-library/buttons/Button';
import * as modals from 'util/Modals';

export default async function runConfirmEditSQLModal(): Promise<boolean> {
  return (await modals.confirm(
    'Edit SQL?',
    'You will not be able to return to the template if you edit the SQL query. Are you sure you want to edit the SQL?',
    ButtonStyle.SECONDARY,
    {
      acceptText: 'Edit SQL',
      rejectText: 'Cancel',
      enableRedesign: true,
      promiseCompatible: true,
    }
  )) as boolean;
}
